'use client';

import React from 'react';
import Link from 'next/link';

import { Media } from '@/components/Media';
import { ArrowForLink } from '@/components/ArrowForLink';
import { NAV } from '@/constants';
import { cn } from '@/utilities/cn';
import type { Post } from '@/payload-types';

export const CardBlog: React.FC<{
  doc: Post;
  className?: string;
}> = ({ doc, className }) => {
  const { title, slug } = doc;

  return (
    <Link
      className={cn('group flex w-full flex-col', className)}
      href={NAV.blogDetail(slug!)}
    >
      <div className="corners-md relative mb-[29px] aspect-[443/280] overflow-hidden md:mb-5">
        <Media resource={doc.mainImage} size="medium" fill />
      </div>
      <h4 className="h6 group-hover:text-blue mb-8 transition md:mb-4">
        {title}
      </h4>
      <ArrowForLink className="mt-auto" />
    </Link>
  );
};
